var exports = {
  "kD": "InboxOptionsTip__49k0xF",
  "UC": "Content__AIwib_",
  "Y9": "Header__LoJDwf",
  "hE": "Title__TfMuks",
  "Jn": "CloseButton__waAl-4",
  "QB": "Message__2OdZWL",
};

module.exports = exports;
